import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/apps/eb-builder/layouts/default.vue").then(m => m.default || m)),
  plain: defineAsyncComponent(() => import("/vercel/path0/apps/eb-builder/layouts/plain.vue").then(m => m.default || m))
}